import { atom } from 'jotai';
import { getMe, isConnectionFailure } from '../lib/api';
import { noteSiteCrm } from '../lib/device-crm';
import type { Me } from '../lib/types';

/** The last confirmed "me", so the app can open with no signal. A convenience, not a security check. */
const LAST_ME_KEY = 'm2q.lastMe';

function rememberMe(me: Me): void {
  try {
    localStorage.setItem(LAST_ME_KEY, JSON.stringify(me));
  } catch {
    // Private mode or storage blocked: the app still works online.
  }
}

function lastMe(): Me | null {
  try {
    const raw = localStorage.getItem(LAST_ME_KEY);
    return raw ? (JSON.parse(raw) as Me) : null;
  } catch {
    return null;
  }
}

/** Who I am. Offline, the last answer the API gave — the API itself still checks every sync. */
export const meAtom = atom(async () => {
  try {
    const me = await getMe();
    rememberMe(me);
    noteSiteCrm(me.crm);
    return me;
  } catch (err) {
    const remembered = isConnectionFailure(err) ? lastMe() : null;
    if (remembered) {
      noteSiteCrm(remembered.crm);
      return remembered;
    }
    throw err;
  }
});
